import { render, staticRenderFns } from "./informationsoftware.vue?vue&type=template&id=502b6f22&scoped=true&"
import script from "./informationsoftware.vue?vue&type=script&lang=js&"
export * from "./informationsoftware.vue?vue&type=script&lang=js&"
import style0 from "./informationsoftware.vue?vue&type=style&index=0&id=502b6f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b6f22",
  null
  
)

export default component.exports